import { render, staticRenderFns } from "./layer-container.vue?vue&type=template&id=1c840044&"
import script from "./layer-container.vue?vue&type=script&lang=js&"
export * from "./layer-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports